module.exports = __webpack_public_path__ + "static/media/wave-1.fefe6dc9.svg";